var map = {
	"./bci-1-hover.svg": 756,
	"./bci-10-hover.svg": 757,
	"./bci-11-hover.svg": 758,
	"./bci-12-hover.svg": 759,
	"./bci-2-hover.svg": 760,
	"./bci-3-hover.svg": 761,
	"./bci-4-hover.svg": 762,
	"./bci-5-hover.svg": 763,
	"./bci-7-hover.svg": 764,
	"./bci-8-hover.svg": 765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2249;